import { useNavigate } from "react-router-dom";
import BackgrounContact from "../../assets/images/BackgroundContact.png";

export default function ContactForm() {
    const navigate = useNavigate();
  return (
    <div className="relative flex items-center justify-center h-screen">
      {/* Fondo decorativo */}
      <div className="absolute inset-0 bg-cover bg-no-repeat bg-center top-0 left-0 bottom-0">
        <img className="object-cover fixed" src={BackgrounContact}></img>
      </div>

      {/* Contenedor del formulario */}
      <div className="relative bg-transparent p-8 md:p-10 rounded-2xl shadow-2xl drop-shadow-lg w-[50%]">
        {/* Encabezado */}
        <h2 className="text-center text-[30px] font-bold text-gray-800 mb-4">
          Déjanos ayudarte!
        </h2>
        <p className="text-center text-gray-500 text-sm mb-8">
          Programemos una llamada para contarte cómo podemos solucionar tus
          necesidades. ¡No te arrepentirás!
        </p>

        {/* Formulario */}
        <form className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <input
              type="text"
              placeholder="¿Cuál es tu nombre?"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <input
              type="text"
              placeholder="¿Cuál es tu apellido?"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <input
              type="text"
              placeholder="Número Celular"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <input
              type="text"
              placeholder="¿Cuál es el nombre de la compañía?"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <textarea
            placeholder="¿Tienes algo que agregar?"
            className="input-field h-24 w-full p-2 rounded-lg"
          ></textarea>

          {/* Aceptar términos */}
          <div className="flex items-center gap-2 py-2">
            <input
              type="checkbox"
              id="terms"
              className="w-4 h-4 accent-blue-500"
            />
            <label htmlFor="terms" className="text-gray-600 text-sm">
              He leído y acepto los{" "}
              <a href="#" className="text-blue-600 font-semibold">
                Términos de Servicio & Política de Privacidad
              </a>
            </label>
          </div>

          <div className="flex w-full justify-center gap-8 mt-4">
            <button onClick={() => navigate("/")} className="border border-bgSecundary text-textSecundary font-semibold py-2 rounded-lg px-6">
              CANCELAR
            </button>
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg px-6">
              PROGRAMAR LLAMADA
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
